import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SharedService } from '../../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { LowerCasePipe } from '@angular/common';
import { CheckAvailabilityService } from '../../check-availability/check-availability.service'
import { TDUModel } from '../../shared/models/shared-models';

const ZIPCODE_REGEX: RegExp = /^[0-9]{5}(?:-[0-9]{4})?$/;

@Component({
	selector: 'app-tdu-details-page',
	templateUrl: './tdu-details-page.component.html',
	styleUrls: ['./tdu-details-page.component.css'],
	providers: [LowerCasePipe]
})
export class TduDetailsPageComponent implements OnInit {
	serviceAddressFormControl = new FormControl('', [Validators.required]);
	apartmentFormControl = new FormControl('', [Validators.required]);

	/** TDUs */
	public tdus: Array<TDUModel> = [];
	public selectedTdu: TDUModel;

	/** Addresses */
	public service_address_search: any = {};
	public service_address_array = [];
	public is_apt_exist: boolean;
	public apt_unit: string = '';
	public apartmentList: any = [];
	public apartmentUnits: any = [];
	public apartment_obs: Observable<string[]>;
	public zipcode: string = '';
	public aptUnitEventKey: number;

	/** Errors */
	public is_error_address: boolean = false;
	public is_error_address_yellow: boolean = false;
	public error_address: string = '';
	public error_address_yellow: string = '';

	/** Search Address */
	public showProgressLoader: boolean = false;
	public which_event: string = '';
	public search_val: any;
	public esiid: string = '';
	public showAddressItems: boolean = false;
	public showAptItems: boolean = false;
	public isCheckAvailabilityDisabled: boolean = true;

	constructor(
		private activatedRoute: ActivatedRoute, private router: Router,
		private sharedService: SharedService, private service: CheckAvailabilityService,
		private localStorageService: LocalStorageService)
	{
		if (this.localStorageService.get('token') != null) {
			this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
				.then(verifyTokenResult => {
					if (verifyTokenResult.status === 'success' && !verifyTokenResult.isTerminated) {
						this.router.navigate(['./dashboard']);
					}
					else {
						this.localStorageService.remove('token');
						this.router.navigate(['./sign-in']);
					}
				});
		}
		else {
			this.sharedService.setHeaderTitle('tdu_detail_hide');
			this.sharedService.setLoader('tdu_detail', true);

			this.activatedRoute.params.subscribe((params: Params) => {

				this.zipcode = params['zipcode'] ? params['zipcode'] : '';

				if (!this.zipcode) {
					this.router.navigate(['./service-not-available']);
				}

				this.sharedService.getTDUsByZipCode(this.zipcode)
					.then(tdusByZipCode => {
						if (tdusByZipCode.status != 'success') {
							this.router.navigate(['./service-not-available']);
						}

						this.tdus = tdusByZipCode.tdus;

						this.sharedService.setHeaderTitle('tdu_detail');
						this.sharedService.setLoader('tdu_detail', false);

						if (!tdusByZipCode.multipleRecord) {
							this.localStorageService.set('zipcode_for_enroll', this.zipcode);
							this.router.navigate([`./enroll/esiid/${this.esiid}/tdu/${tdusByZipCode.tdus[0].tduCode}`]);
						}
					});
			});
		}
	}

	ngOnInit() {

		this.serviceAddressFormControl.valueChanges.subscribe(searchKey => {

			if (!searchKey || searchKey.trim().length <= 2) {
				this.service_address_array = [];
				this.showAddressItems = false;
				return;
			}

			searchKey = searchKey.trim();

			this.service.direct_search(searchKey)
				.then((addressSearchResult) => {

					this.service_address_array = [];
					if (addressSearchResult && addressSearchResult["value"] && addressSearchResult["value"].length > 0) {
						this.service_address_array = addressSearchResult["value"];
					}

					setTimeout(() => {
						this.showAddressItems = this.service_address_array.length > 0 && !this.isInAddressArray(searchKey);
					}, 100);

					if (this.service_address_array.length == 0) {
						this.is_error_address_yellow = true;
					}
				});
		});
	}

	redirectToPlanDetails(tdu: string) {
		let url = './enroll' + (this.zipcode ? ('/zipcode/' + this.zipcode) : '');
		this.router.navigate([url + '/tdu/' + tdu]);
	}

	getAddressWithoutApt(address: string) {
		let address_part = address.split(",");
		let new_address = "";
		if (address_part != null && address_part.length > 5) {
			new_address = address_part[0] + "," + address_part[1] + "," + address_part[3] + "," + address_part[4] + "," + address_part[5]
		} else {
			new_address = address;
		}

		return new_address
	}

	searchAddress(event_value: string) {
		this.is_error_address = false;
		this.is_error_address_yellow = false;
		this.is_apt_exist = false;
		this.apt_unit = '';
		this.esiid = '';
		this.apartmentList = [];

		let address_hash = this.getHashKeyFromAddress(event_value);

		if (address_hash != undefined && address_hash.trim() != '') {
			this.selectAddressHash(address_hash);
		}
		else if (event_value.match(ZIPCODE_REGEX)) {
			this.selectAddressHash(event_value);
		}
		else {
			if (event_value != undefined && event_value.trim() != '' && this.service_address_array.length == 0) {
				this.is_error_address_yellow = true;
				this.selectAddressHash(event_value);
			}
		}
	}

	getHashKeyFromAddress(address) {
		for (let i = 0; i < this.service_address_array.length; i++) {
			let service_address = this.service_address_array[i];
			if (service_address["address_full"].trim() == address.trim()) {
				return service_address["FullAddressHashKey"];
			}
		}
		return "";
	}

	aptUnitEvent(event) {
		const enter_key = event.keyCode || event.which;

		if (event.type === 'keyup' && (enter_key === 13) || (this.aptUnitEventKey === 17 && enter_key === 86) ||
			(this.aptUnitEventKey === 86 && enter_key === 17)) {
			this.sharedService.InvokeHtmlElementEvent('apartment', 'blur');
		}
		this.aptUnitEventKey = enter_key;
	}

	selectServiceAddress(service_address_search_text) {
		this.service_address_search = service_address_search_text;

		setTimeout(() => {
			this.showAddressItems = false;
			this.sharedService.InvokeHtmlElementEvent('service_address_id', 'blur');
		}, 200);
	}

	isInAddressArray(key: string) {
		let inArray: boolean = false;
		for (let i = 0; i < this.service_address_array.length; i++) {
			let arr_ele = this.service_address_array[i];
			if (arr_ele["address_full"].trim() == key.trim()) {
				inArray = true;
				break;
			}
		}
		return inArray;
	}

	isInApartmentArray(key: string) {
		let inArray: boolean = false;
		for (let i = 0; i < this.apartmentList.length; i++) {
			let arr_ele = this.apartmentList[i];
			if (arr_ele.toString().trim() == key.trim()) {
				inArray = true;
				break;
			}
		}
		return inArray;
	}

	selectAddress(service_address_search_text) {
		this.service_address_search["text"] = service_address_search_text;

		setTimeout(() => {
			this.showAddressItems = false;
			this.sharedService.InvokeHtmlElementEvent('service_address_id', 'blur');
		}, 200);

		this.searchAddress(service_address_search_text);
	}

	/** Search Electric Utility Provider (TDUs) for the address or zip-code */
	selectAddressHash(address_hash: string) {

		address_hash = address_hash ? address_hash.trim() : '';

		// Invalid search
		if (address_hash == '') {
			this.isCheckAvailabilityDisabled = false;
			return;
		}

		this.showProgressLoaderControl(true);

		let requestObj = {
			'addressHash': address_hash.trim()
		};

		this.service.GetServiceAddressesByHash(requestObj)
			.then(response => {

				// Address not found
				if (response.result.length < 0) {
					let dataLayerEvent = 'enroll - step 0: address issue';
					(window as any).dataLayer.push({ 'event': dataLayerEvent, 'error address_hash': address_hash });
					this.is_error_address_yellow = true;
					this.error_address_yellow = this.sharedService.getErrorMessage('address_not_found');
					this.isCheckAvailabilityDisabled = true;
					return;
				}

				// Show the Apartment Unit selector if needed
				this.showApartmentUnitSelector(response);
				this.showProgressLoaderControl(false);
			});
	}

	scrollToHere(event) {
		this.sharedService.ScrollToHere(event);
	}

	/** Show the Apartment Unit selector  */
	showApartmentUnitSelector(serviceAddressResponse: any) {
		this.apartmentUnits = serviceAddressResponse.result;
		this.apartmentList = [];

		for (let i = 0; i < this.apartmentUnits.length; i++) {
			if (this.apartmentUnits[i].aptUnit != null && this.apartmentUnits[i].aptUnit !== '') {
				let apartment: string = this.apartmentUnits[i].aptUnit;
				this.apartmentList.push(apartment);
			}
		}

		// No apartments found
		this.is_apt_exist = this.apartmentList.length > 0;
		if (!this.is_apt_exist) {
			this.chooseAparmentUnit('', serviceAddressResponse.result[0]);
			this.isCheckAvailabilityDisabled = false;
			this.sharedService.InvokeHtmlElementEvent('home_next', 'focus');
			return;
		}

		this.showAptItems = true;
		this.apartment_obs = this.apartmentFormControl.valueChanges.startWith(null).map(val => val
			? this.filterApartment(val)
			: this.apartmentList.slice());

		if (serviceAddressResponse.result.length === 1) {
			this.apt_unit = this.apartmentList[0];
			this.chooseAparmentUnit(this.apt_unit, undefined);
		}
		else {
			if (this.apartmentList.length == 1) {
				this.apt_unit = this.apartmentList[0];
				this.chooseAparmentUnit(this.apt_unit, undefined);
			}
			else {
				setTimeout(() => { this.sharedService.InvokeHtmlElementEvent('apartment', 'focus'); }, 100);
			}
		}
	}

	/** Apartment auto-complete filter */
	filterApartment(val: string): string[] {
		setTimeout(() => {
			let isInApt: boolean = this.isInApartmentArray(val);
			this.showAptItems = this.apartmentList.length > 0;
			if (isInApt) {
				this.chooseAparmentUnit(this.apt_unit, '');
			}
		}, 100);

		return this.apartmentList.filter(option => option.toLowerCase().includes(val.toLowerCase()) === true);
	}

	chooseAparmentUnit(apt_number: string, address_obj: any)
	{
		if (!apt_number && !address_obj) {
			return;
		}

		this.showAptItems = false;
		this.isCheckAvailabilityDisabled = true;

		if (apt_number) {
			for (let i = 0; i < this.apartmentUnits.length; i++) {
				if (this.apartmentUnits[i].aptUnit === apt_number) {
					address_obj = this.apartmentUnits[i];
					this.apt_unit = this.apartmentUnits[i].aptUnit;
				}
			}
		}

		if (!address_obj) {
			return;
		}

		this.sharedService.InvokeHtmlElementEvent('home_next', 'focus');
		this.selectedTdu = this.tdus.find((x) => x.duns == address_obj.duns);
		this.esiid = address_obj.esiId;
		this.localStorageService.set('address_for_billing', address_obj);

		// TODO - lifting up setting this 'state' on a 'success'
		// because otherwise will prevent us from navigating.
		//
		this.is_error_address = false;
		this.is_error_address_yellow = false;
		this.isCheckAvailabilityDisabled = false;
		if (address_obj.aptUnit != null && address_obj.aptUnit !== '') {
			this.is_apt_exist = true;
		}
	}

	showProgressLoaderControl(show: boolean) {
		this.showProgressLoader = show;
	}

	goToPlanDetails() {
		if (this.selectedTdu && this.esiid) {
			this.router.navigate([`./enroll/esiid/${this.esiid}/tdu/${this.selectedTdu.tduCode}`]);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/service-availability/tdu-details-page/tdu-details-page.component.ts